const BASE_URL = "https://api.xdiasporamedia.com/api/";

export default BASE_URL;
